import { render, staticRenderFns } from "./GreenInfoBox.vue?vue&type=template&id=2bd45889&scoped=true"
import script from "./GreenInfoBox.vue?vue&type=script&lang=js"
export * from "./GreenInfoBox.vue?vue&type=script&lang=js"
import style0 from "./GreenInfoBox.vue?vue&type=style&index=0&id=2bd45889&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd45889",
  null
  
)

export default component.exports